import { Container, Row, Col } from "react-bootstrap";

export default function PublicSiteFooter() {
    return (
        <>
            {/* ======================footer section==================================== */}
            < footer className="footer-section" >
                <Container>

                    <Row className="">
                        <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                            <div className='footer-col-1'>
                                <h2 className='footer-col-heading'>Related<br /> <span>Links</span>
                                </h2>
                            </div>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={4} sm={6} xs={12}>
                                    <ul className="footer-links-list">
                                        <li><a href="https://ap.gov.in">ap.gov.in</a></li>
                                        <li><a href="https://apfinance.gov.in">apfinance.gov.in</a></li>
                                        <li><a href="https://ap.gov.in">cfms.ap.gov.in</a></li>
                                        <li><a href="https://ap.gov.in">dwa.ap.gov.in</a></li>
                                        <li><a href="https://ap.gov.in">dsa.ap.gov.in</a></li>
                                        <li><a href="https://ap.gov.in">treasury.ap.gov.in</a></li>
                                    </ul>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={4} sm={6} xs={12}>
                                    <ul className="footer-links-list offset-list">
                                        <li><a href="https://ap.gov.in">swreis.ap.gov.in</a></li>
                                        <li><a href="https://apcfss.in">apstudycircle.apcfss.in</a></li>
                                        <li><a href="https://ap.gov.in">bie.ap.gov.in</a></li>
                                        <li><a href="https://ap.gov.in">nivas.apcfss.in</a></li>
                                        <li><a href="https://apcfss.in">Jnanabhumi.ap.gov.in</a></li>
                                    </ul></Col>
                            </Row>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
                            <div className='footer-col-2'>
                                <div className='footer-col-2-div'>
                                    <h2 className='footer-col-heading'>Website
                                        <br /> <span>Policies</span>
                                    </h2>
                                    <div className='social-links-div'>
                                        <a href="#" className="social-icon-link"><div className='facebook'>
                                            <img src="../images/facebook.svg" className='img-fluid' />
                                        </div></a>
                                        <a href="#" className="social-icon-link">  <div className='facebook'>
                                            <img src="../images/twitter.svg" className='img-fluid' />
                                        </div></a>
                                        <a href="#" className="social-icon-link">  <div className='facebook'>
                                            <img src="../images/youtube.svg" className='img-fluid' />
                                        </div></a>
                                        <a href="#" className="social-icon-link"> <div className='facebook'>
                                            <img src="../images/instagram.svg" className='img-fluid' />
                                        </div></a>
                                    </div>
                                </div>

                            </div>
                            <Row>
                                <Col xxl={4} xl={4} lg={4} md={3} sm={6} xs={12}>  <ul className="footer-links-list">
                                    <li><a href="#">Copyright Policy</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                    <li><a href="#">Hyperlinking Policy</a></li>
                                    <li><a href="#">Terms of Use</a></li>
                                </ul>
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={3} sm={6} xs={12}>  <ul className="footer-links-list">  <li><a href="#">About Us</a></li>
                                    <li><a href="#">Contact Us</a></li>
                                    <li><a href="#">Feedback</a></li>
                                    <li><a href="#">FAQs</a></li>
                                    <li><a href="#">Help</a></li>
                                    <li><a href="#">Sitemap</a></li>
                                    <li><a href="#">Website policy</a></li>
                                    <li><a href="#">Disclaimer</a></li></ul></Col>
                                <Col xxl={4} xl={4} lg={4} md={3} sm={6} xs={12}>
                                    <ul className="footer-links-list footer-last-col">
                                        <li><a href="#">Sitemap</a></li>
                                        <li><a href="#">Website policy</a></li>
                                        <li><a href="#">Disclaimer</a></li></ul>
                                </Col>
                            </Row>

                        </Col>


                    </Row>


                    {/* <Row>
                        <Col className="timestamp-col">
                            <span className="timestamp-text">Last reviewed and updated on 10 June 2026 at 04:14:15pm</span>
                        </Col>
                    </Row> */}
                </Container>

                <div className='footer-bottom-text'>
                    <p>Last reviewed and updated on 29 June 2026 at 11:44 AM</p>
                </div>

            </footer >
            <div className='footer-bottom-content'>
                <Container>
                    <div className='copyright-text-div'>
                        <p>Copyright © 2026 AP KWDC All Rights Reserved</p>
                        <p>Designed and Developed by<a href='https://apcfss.in/'> <img src="../images/footer-logo.svg" /></a></p>
                    </div>


                </Container>
                <div className='info-div'>
                    <Container>
                        <p className='info-text'>All information, data, and materials published on this portal are owned and approved by the Director, Andhra Pradesh Government Kapu Welfare Department. The Director is responsible for ensuring the accuracy, authenticity, and timely updating of the content displayed on this website.</p>
                    </Container>

                </div>
                <Container fluid className='px-0'>
                    <div className='disclaimer-div'>
                        <Container>
                            <Row>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={12} className='disclamer-col'>
                                    <div className='disclaimer-text-div'>
                                        <h4>Translation Disclaimer</h4>
                                    </div>
                                </Col>
                                <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={12}>
                                    <div className='disclaimer-text-div2'>
                                        <p>This website has been translated into multiple languages for the convenience of users. While every effort has been made to ensure the accuracy, correctness, and reliability of the translated content, the English version (or original language version) shall prevail in case of any variation or discrepancy. The translated content is provided through automated/assisted translation tools, and therefore may not be fully accurate or reflect the intended meaning of the original text. The Department / Organisation does not accept any responsibility for errors or omissions that may occur due to translation. Users are advised to refer to the original version of the website for official and legally valid information. If any inconsistency is observed, kindly report it to the website administrator for corrective action.</p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>


                </Container>

            </div>
        </>
    );
}
